module.exports = __webpack_public_path__ + "static/img/Electric Insulation Silicone Rubber.8471b20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/Electric Insulation Silicone Rubber.jpg
// module id = 8/tY
// module chunks = 1